if (!customElements.get('product-details')) {
  customElements.define(
    'product-details',
    class ProductDetails extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
      }

      get sectionId() {
        return this.getAttribute('data-section-id');
      }

      get productUrl() {
        return this.getAttribute('data-product-url');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = theme.pubsub.subscribe(
          theme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.abortController?.abort();
      }

      handleVariantChange({ data }) {
        console.log(data);
        const variant = data.variant;
        if (!variant) return;

        const requestUrl = this.buildRequestUrl(variant.id);

        this.renderProductDetails({
          requestUrl,
          callback: this.handleUpdateProductDetails(),
        });
      }

      buildRequestUrl(variantId) {
        const params = [];

        params.push(`section_id=${this.sectionId}`);
        if (variantId) {
          params.push(`variant=${variantId}`);
        }

        return `${this.productUrl}?${params.join('&')}`;
      }

      renderProductDetails({ requestUrl, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Product details fetch aborted');
            } else {
              console.error(error);
            }
          });
      }

      handleUpdateProductDetails() {
        return (html) => {

          const updateSourceFromDestination = (id) => {
            const source = html.getElementById(`${id}-${this.sectionId}-${this.productId}`);
            const destination = document.querySelector(`#${id}-${this.sectionId}-${this.productId}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }
          };

          updateSourceFromDestination('ProductDetails');

        };
      }
    }
  );
}
